import React from "react";

// import react-dates datepicker
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { DateRangePicker } from "react-dates";
import moment, { Moment } from "moment";

export interface IDateRangePickerProps {
  startDate: any;
  endDate: any;
  setStartDate: React.Dispatch<React.SetStateAction<any>>;
  setEndDate: React.Dispatch<React.SetStateAction<any>>;
  focusedInput: any;
  setFocusedInput: React.Dispatch<React.SetStateAction<any>>;
  preventPastDates?: boolean;
  minimumNights?: any;
}

const CustomDateRangePicker: React.FC<IDateRangePickerProps> = ({
  startDate,
  endDate,
  focusedInput,
  setStartDate,
  setEndDate,
  setFocusedInput,
  preventPastDates,
  minimumNights = 1,
}) => {
  return (
    <DateRangePicker
      startDate={startDate}
      endDate={endDate}
      // minDate={startDate}
      startDateId="rateplan-start-date"
      endDateId="rateplan-end-date"
      displayFormat="DD MMM, YYYY"
      onDatesChange={({ startDate, endDate }) => {
        setStartDate(startDate);
        setEndDate(endDate);
      }}
      focusedInput={focusedInput}
      isOutsideRange={
        preventPastDates ?
          (day) => day.isBefore(moment(), "day") // Block past dates
        : () => false // Allow all dates
      }
      onFocusChange={(focusedInput: any) => setFocusedInput(focusedInput)}
      minimumNights={minimumNights}
    />
  );
};

export default CustomDateRangePicker;
